module.exports = __webpack_public_path__ + "img/title.ae206c23.png";